module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "largelogin"
  }, [_c('div', {
    staticClass: "panelheader border-blue"
  }, [_c('div', {
    staticClass: "booker-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.showLogin) ? _c('div', [_c('loginform'), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeToRegister
    }
  }, [_vm._v("Register")])], 1) : _c('div', [_c('registerform', {
    on: {
      "login": _vm.changeToLogin
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1421f16","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booker/LargeLogin.vue
// module id = 881
// module chunks = 2